import { render, staticRenderFns } from "./CompanyCards.vue?vue&type=template&id=b8ccbd9c&scoped=true&"
import script from "./CompanyCards.vue?vue&type=script&lang=js&"
export * from "./CompanyCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ccbd9c",
  null
  
)

export default component.exports